<template>
  <el-dialog
    v-el-drag-dialog
    :title="L('PublishInfo')"
    :visible.sync="selfVisible"
    :modal-append-to-body="false"
    @open="handleOpen"
    @close="handleClose"
    width="50%"
  >
    <el-form size="small" :model="model" label-position="right" label-width="110px">
      <el-form-item label="发布版本号：" prop="code">{{model.code}}</el-form-item>
      <el-form-item label="发布时间：">{{publishTimeStr}}</el-form-item>
      <el-form-item label="发布简介：" prop="intro">{{model.intro}}</el-form-item>
      <el-scrollbar style=" height: 380px;" class="hidden-overflow-x">
        <el-form-item label="发布功能要点：" prop="feature">
          <div v-html="model.feature"></div>
        </el-form-item>
        <el-form-item label="操作说明：" prop="operationManual">
          <div v-html="model.operationManual"></div>
        </el-form-item>
        <el-form-item label="附件：" prop="adjunct">
          <div v-for="(item,index) in addRange" :key="index">
            <video
              controls
              name="media"
              v-if="getsrc(item)"
              style="width:500px;"
              :src="getsrc(item)"
            ></video>
            <el-button
              size="mini"
              v-if="model.adjunct && !getsrc(item)"
              @click="download(item)"
            >下载附件</el-button>
          </div>
        </el-form-item>
      </el-scrollbar>
      <el-form-item label="上一版本：" v-if="last">
        <div class="cursorpoint" @click="initData(last.id)">{{last.code}} 发布功能：{{last.intro}}</div>
      </el-form-item>
      <el-form-item label="下一版本：" v-if="next">
        <div class="cursorpoint" @click="initData(next.id)">{{next.code}} 发布功能：{{next.intro}}</div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
export default {
  props: {
    display: Boolean,
  },
  data() {
    var self = this;
    return {
      maxheight:
        document.documentElement.clientHeight ||
        document.body.clientHeight - 800,
      selfVisible: this.display,
      loading: false,
      publishTimeStr: "",
      model: {},
      addRange: [],
      last: {},
      next: {},
      url: config.BASE_Middle_API + "PublishInfoUsers/GetPublishInfo",
    };
  },
  watch: {
    // 监控父组件传递过来的值来指示是否显示dialog
    display(val) {
      if (val != this.selfVisible) {
        this.selfVisible = val;
      }
    },
    // 监控本组件的显示状态
    selfVisible(val) {
      // 更新状态到父组件是否显示本对话框
      this.$emit("update:display", val);
    },
  },
  async created() {},
  methods: {
    handleOpen() {},
    handleClose() {},
    initData(id) {
      const _this = this;
      AjaxHelper.get(_this.url, { id: id })
        .then(function (rs) {
          _this.publishTimeStr = rs.result.publishTimeStr;
          _this.model = rs.result.publish;
          if (_this.model.adjunct != "" && _this.model.adjunct != null) {
            _this.addRange = _this.model.adjunct.split(",");
          }
          _this.last = rs.result.last;
          _this.next = rs.result.next;
        })
        .catch(function (error) {
          _this.$message({
            type: "error",
            message: error,
          });
        });
    },
    getsrc(src) {
      var url = "";
      if (src != null && src != "") {
        src = src.toLowerCase();
        if (
          src.indexOf(".mov") !== -1 ||
          src.indexOf(".mpg") !== -1 ||
          src.indexOf(".dat") !== -1 ||
          src.indexOf(".avi") !== -1 ||
          src.indexOf(".mp4") !== -1
        ) {
          src = src.replace("\\", "//");
          url = config.remoteUrl + "/" + src;
        }
      }
      return url;
    },
    download(src) {
      var url = "";
      if (src != null && src != "") {
        src = src.toLowerCase();
        src = src.replace("\\", "//");
        url = config.remoteUrl + "/" + src;
      }
      window.open(url);
      return url;
    },
  },
};
</script>

<style scoped>
>>> img {
  max-width: 100% !important;
}
.hidden-overflow-x {
  overflow-x: hidden;
}
.cursorpoint {
  cursor: pointer;
}
.ql-video {
  height: 400px;
  width: 100%;
}
</style>